export enum RoleEnum {
    USER = 0,
    ADMIN = 1,
    BLOCKED = 2
}